<template>
  <Problem :son="22" :questions="questions" />
</template>

<script>
import Problem from '@/components/experimentation/problem .vue'
export default {
  components: { Problem },
  props: [],
  data() {
    return {
      questions: [
        {
          id: 0,
          question: 'lang.ct.two.two.ll_chird.firstQ.question',
          options: [
            { value: 'A', label: 'lang.ct.two.two.ll_chird.firstQ.option.A' },
            { value: 'B', label: 'lang.ct.two.two.ll_chird.firstQ.option.B' },
            { value: 'C', label: 'lang.ct.two.two.ll_chird.firstQ.option.C' },
            { value: 'D', label: 'lang.ct.two.two.ll_chird.firstQ.option.D' },
          ],
          answer: '',
          result: 'A',
          score: 2,
          scored: 0,
        },
        {
          id: 1,
          question: 'lang.ct.two.two.ll_chird.secondQ.question',
          options: [
            { value: 'A', label: 'lang.ct.two.two.ll_chird.secondQ.option.A' },
            { value: 'B', label: 'lang.ct.two.two.ll_chird.secondQ.option.B' },
            { value: 'C', label: 'lang.ct.two.two.ll_chird.secondQ.option.C' },
            { value: 'D', label: 'lang.ct.two.two.ll_chird.secondQ.option.D' },
          ],
          answer: '',
          result: 'D',
          score: 2,
          scored: 0,
        },
      ],
    }
  },
}
</script>